import { useEffect, useState } from "react"
import { getAllArticles, searchArticle } from "../utils/requests/knowladgebase"

const useArticlesSearch = (page: number = 0, searchQuery?: string) => {
  const [loading, setLoading] = useState(false)

  const [articles, setArticles] = useState<KnowladgebaseArticleResponse[]>([])
  const [currentPage, setCurrentPage] = useState(0)
  const [totalPages, setTotalPages] = useState(0)

  const fetchTeachers = async () => {
    setLoading(true)
    const articlesRes = await getAllArticles(page)
    console.log({ articlesRes })
    if (!articlesRes.success) {
      setLoading(false)
      return
    }

    setArticles(articlesRes.articles)
    setTotalPages(articlesRes.totalPages)
    setCurrentPage(articlesRes.currentPage)

    setLoading(false)
  }

  const fetchSearchResults = async (query: string) => {
    if (!query) {
      return
    }

    setLoading(true)
    const articlesRes = await searchArticle(query)

    if (!articlesRes.success) {
      setLoading(false)
      return
    }

    setArticles(articlesRes.articles)
    setLoading(false)
  }

  useEffect(() => {
    if (!searchQuery || searchQuery.length < 3) {
      fetchTeachers()
      return
    }
    fetchSearchResults(searchQuery)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchQuery, page])

  return { articles, loading, currentPage, totalPages }
}

export default useArticlesSearch
